import dynaForms from '@elab/core/utils/dynaForms';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    CONSENT_NEEDED_DIALOG: `${storeName}.CONSENT_NEEDED_DIALOG`,
    DO_ADDRESS_VERIFICATION: `${storeName}.DO_ADDRESS_VERIFICATION`,
    SHOULD_PREFILL_FORM: `${storeName}.SHOULD_PREFILL_FORM`,
    SET_FAKE_VALIDATION: `${storeName}.SET_FAKE_VALIDATION`,
    SHOULD_PREFILL_PHONE: `${storeName}.SHOULD_PREFILL_PHONE`,
    PRESERVE_PHONE_NUMBER_PATTERN: `${storeName}.PRESERVE_PHONE_NUMBER_PATTERN`,
});

export default getTypes;
